import { Textrotator } from "./modules/_textrotator.mjs";

document.addEventListener("DOMContentLoaded", function () {
    const textrotator = new Textrotator();

    const targets = [
        {
            element: document.getElementById("highlighted-event"),
            toggle: document.querySelector('[aria-controls="highlighted-event"]')
        },
        {
            element: document.getElementById("navigation-first-level"),
            toggle: document.querySelector('[aria-controls="navigation-first-level"]')
        },
        {
            element: document.getElementById("navigation-menu-fitlance"),
            toggle: document.querySelector('[aria-controls="navigation-menu-fitlance"]')
        }
    ];

    function fadeOut(element) {
        element.style.opacity = "0";
        element.classList.add("transitioning");
        element.addEventListener("transitionend", function () {
            element.classList.remove("active", "transitioning");
        }, { once: true });
    }

    function fadeIn(element) {
        element.classList.add("active", "transitioning");
        element.style.opacity = "0";
        requestAnimationFrame(() => {
            setTimeout(() => {
                element.style.opacity = "1";
            });
        });
        element.addEventListener("transitionend", function () {
            element.classList.remove("transitioning");
        }, { once: true });
    }


    targets.forEach(({ element, toggle }) => {
        if (!element || !toggle) return; // Skip if either is missing

        toggle.addEventListener("click", (e) => {
            const isActive = toggle.classList.contains("active");
            if (isActive && !element.classList.contains("transitioning")) {
                toggle.classList.remove("active");
                fadeOut(element);
            } else {
                toggle.classList.add("active");
                fadeIn(element);
            }
        });
    });

    // Outside click listener
    document.addEventListener("click", function (event) {
        targets.forEach(({ element, toggle }) => {
            const clickedInsideElement = element.contains(event.target);
            if (!toggle) return;
            const clickedToggle = toggle.contains(event.target);

            // If click was outside both the menu and the toggle, close it
            if (!clickedInsideElement && !clickedToggle) {
                if (element.classList.contains("active")) {
                    fadeOut(element);
                    toggle.classList.remove("active");
                }
            }
        });
    });
});